import LogoDark from 'assets/logo-black.png';
import Link from 'components/Link';
import { Theme } from 'containers/Sidebar/themes';
import React from 'react';
import LogoLight from 'assets/logo-white.png';

interface Props {
  theme: Theme;
  to?: string;
}

export function Logo({ theme, to = '/' }: Props) {
  return (
    <Link aria-label="home" to={to}>
      <img
        style={{ height: '30px' }}
        alt="Teetsh"
        src={theme === 'dark' ? LogoLight : LogoDark}
      />
    </Link>
  );
}
